(function () {
  // ---------------------------------------------------------------------------
  // Kustom Elements on product pages — payment/delivery method logos and
  // express (wallet) buttons, rendered by Kustom's hosted web components.
  //
  // Driven entirely by Theme settings exposed via snippets/kustom-config.liquid
  // as window.__kustomCheckout.elements:
  //   - key       Elements public API key (client id) — REQUIRED; without it
  //               this script does nothing. The key is provisioned on the
  //               merchant's Kustom account (the page origin must be on the
  //               client's allow-list).
  //   - payment   show available payment methods under the buy button
  //   - delivery  show available delivery methods under the buy button
  //   - express   show express wallet buttons (Apple Pay / Google Pay / PayPal…)
  //               above the buy button; buttons only render in browsers that
  //               actually have a wallet available
  //
  // The global kill switch + market allowlist (same Theme settings that gate
  // the Kustom checkout button) apply here too — turning Kustom off removes
  // the logos and express buttons along with the button.
  //
  // Everything is additive and best-effort: no theme element is removed or
  // replaced, and any failure leaves the product page exactly as it was.
  // ---------------------------------------------------------------------------

  function cfg() {
    var c = window.__kustomCheckout || {};
    var e = c.elements || {};
    return {
      enabled: c.enabled !== false,
      markets: typeof c.markets === 'string' ? c.markets : '',
      country: String(c.country || (window.Shopify && window.Shopify.country) || 'SE').toUpperCase(),
      environment: c.environment === 'production' ? 'production' : 'playground',
      key: typeof e.key === 'string' ? e.key.trim() : '',
      payment: e.payment === true,
      delivery: e.delivery === true,
      express: e.express === true,
    };
  }

  function marketAllowed(c) {
    if (!c.markets) return true;
    var list = c.markets.toUpperCase().split(/[^A-Z]+/).filter(Boolean);
    return !list.length || list.indexOf(c.country) !== -1;
  }

  // 5-char market locale ("sv-SE") from the theme's language + market country.
  function marketLocale(c) {
    var lang = (window.Shopify && window.Shopify.locale) || 'en';
    lang = String(lang).split('-')[0] || 'en';
    return lang + '-' + c.country;
  }

  var SCRIPT_URLS = {
    production: 'https://js.live.kustom.co/kustom-elements/v1/pre-load.js',
    playground: 'https://js.playground.kustom.co/kustom-elements/v1/pre-load.js',
  };

  // pre-load.js writes into window.kustomElements._internal and drains the
  // command queue at _internal.q WITHOUT initializing the global itself — a
  // gtag-style stub must exist before the script runs or its loader crashes.
  function ensureStub() {
    var w = window;
    if (typeof w.kustomElements === 'function' && w.kustomElements._internal) return;
    var stub = function () { stub._internal.q.push(arguments); };
    stub._internal = { q: [] };
    w.kustomElements = stub;
  }

  var scriptInjected = false;
  function loadElementsScript(c) {
    if (scriptInjected) return;
    scriptInjected = true;
    ensureStub();
    var s = document.createElement('script');
    s.src = SCRIPT_URLS[c.environment];
    s.async = true;
    s.setAttribute('data-public-api-key', c.key);
    document.head.appendChild(s);
  }

  // The theme's buy-button block on the product page. Prefer the standard
  // wrapper (Dawn & friends), fall back to the add-to-cart form itself.
  function findBuyBlock() {
    var el = document.querySelector('.product-form__buttons');
    if (el) return { anchor: el, mode: 'around' };
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form) return { anchor: form, mode: 'around' };
    return null;
  }

  function readVariantId(scopeEl) {
    var form = scopeEl.closest ? (scopeEl.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]')) : document.querySelector('form[action*="/cart/add"]');
    var input = form && form.querySelector('[name="id"]');
    return input && input.value ? String(input.value) : null;
  }

  function readQuantity() {
    var input = document.querySelector('form[action*="/cart/add"] [name="quantity"], input[name="quantity"]');
    var n = input ? parseInt(input.value, 10) : 1;
    return isNaN(n) || n < 1 ? 1 : n;
  }

  // Product JSON for the current PDP — /products/{handle}.js (prices in the
  // presentment currency's minor units).
  var productPromise = null;
  function fetchProduct() {
    if (!productPromise) {
      productPromise = fetch(window.location.pathname.replace(/\/$/, '') + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productPromise;
  }

  function onProductPage() {
    return /\/products\//.test(window.location.pathname) && !!document.querySelector('form[action*="/cart/add"]');
  }

  var mounted = false;
  async function mount() {
    if (mounted || !onProductPage()) return;
    var c = cfg();
    if (!c.enabled || !c.key || !marketAllowed(c)) return;
    if (!c.payment && !c.delivery && !c.express) return;
    var block = findBuyBlock();
    if (!block) return;
    mounted = true;

    loadElementsScript(c);
    var locale = marketLocale(c);

    // Express buttons go ABOVE the buy button, method logos BELOW — the
    // conventional placement on Shopify PDPs.
    if (c.express) {
      var expressWrap = document.createElement('div');
      expressWrap.setAttribute('data-kustom-elements', 'express');
      expressWrap.style.margin = '0 0 12px';
      var expressEl = document.createElement('kustom-express-buttons');
      expressEl.id = 'kustom-express-pdp';
      expressEl.setAttribute('locale', locale.toLowerCase());
      expressWrap.appendChild(expressEl);
      block.anchor.parentNode.insertBefore(expressWrap, block.anchor);
      initExpress(c, locale);
    }

    if (c.payment || c.delivery) {
      var displayWrap = document.createElement('div');
      displayWrap.setAttribute('data-kustom-elements', 'display');
      displayWrap.style.margin = '12px 0 0';
      if (c.payment) {
        var pay = document.createElement('kustom-payment-method-display');
        pay.setAttribute('locale', locale);
        displayWrap.appendChild(pay);
      }
      if (c.delivery) {
        var del = document.createElement('kustom-delivery-method-display');
        del.setAttribute('locale', locale);
        displayWrap.appendChild(del);
      }
      block.anchor.parentNode.insertBefore(displayWrap, block.anchor.nextSibling);
    }
  }

  // Express: the wallet sheet shows display lines immediately; the REAL Kustom
  // order (correct prices/tax, computed server-side by the bridge Worker) is
  // created by the createOrder hook when the shopper opens a wallet.
  function initExpress(c, locale) {
    var currency =
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'SEK';

    var createOrder = function (resolve, reject) {
      fetchProduct().then(function (product) {
        var variantId = readVariantId(document.querySelector('#kustom-express-pdp')) || (product && product.variants && product.variants[0] && String(product.variants[0].id));
        if (!product || !variantId) { reject(new Error('Product unavailable')); return; }
        var variant = null;
        for (var i = 0; i < (product.variants || []).length; i++) {
          if (String(product.variants[i].id) === variantId) { variant = product.variants[i]; break; }
        }
        if (!variant) { reject(new Error('Variant unavailable')); return; }
        var quantity = readQuantity();
        // Same shape kustom-checkout.js sends from /cart.js — the Worker
        // treats it identically (prices in minor units).
        var body = {
          items: [{
            variant_id: variant.id,
            product_title: product.title,
            variant_title: variant.title,
            quantity: quantity,
            price: variant.price,
            line_price: variant.price * quantity,
            featured_image: (variant.featured_image && { url: variant.featured_image.src }) || (product.featured_image && { url: product.featured_image }) || null,
          }],
          total_price: variant.price * quantity,
          _market: { country: cfg().country, currency: currency, locale: locale },
          _variant: 'kustom',
          _checkout: (window.__kustomCheckout && window.__kustomCheckout.checkout) || null,
        };
        return fetch('https://kustom-checkout-switch-nails.switch-nails.workers.dev/create-order', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        }).then(function (r) { return r.json(); }).then(function (data) {
          if (data && data.order_id) resolve({ orderId: data.order_id });
          else reject(new Error((data && data.error) || 'Order creation failed'));
        });
      }).catch(reject);
    };

    var doInit = function () {
      fetchProduct().then(function (product) {
        var variantId = readVariantId(document.body);
        var variant = null;
        if (product) {
          for (var i = 0; i < (product.variants || []).length; i++) {
            if (String(product.variants[i].id) === variantId) { variant = product.variants[i]; break; }
          }
          if (!variant) variant = product.variants && product.variants[0];
        }
        var quantity = readQuantity();
        var total = variant ? variant.price * quantity : 0;
        window.kustomElements('express.initialize', '#kustom-express-pdp', {
          currency: currency.toLowerCase(),
          orderLines: [{
            name: (product && product.title) || document.title,
            totalAmount: total,
            // Display-only: the sheet's initial lines. The createOrder hook
            // replaces them with the Worker-computed order (correct tax).
            taxAmount: 0,
            quantity: quantity,
          }],
          shippingAddressRequired: true,
          createOrder: createOrder,
          onConfirm: function (response) {
            if (response && response.redirectUrl) window.location.href = response.redirectUrl;
          },
        });
      });
    };
    ensureStub();
    doInit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }
})();
